/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Track_Draw_HintInputs */



/**
* | output |
* | --- |
* | "Click and drag to create events" |
*
* @param {Timeline_Track_Draw_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_track_draw_hint = /** @type {((inputs?: Timeline_Track_Draw_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Track_Draw_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquez et faites glisser pour creer des evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Klicken und ziehen Sie, um Ereignisse zu erstellen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fai clic e trascina per creare eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для создания событий используйте перетаскивание мышью.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haga clic y arrastre para crear eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("点击并拖动即可创建事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クリックしてドラッグしてイベントを作成します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट बनाने के लिए क्लिक करें और ड्रैग करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Clique e arraste para criar eventos.")
	return /** @type {LocalizedString} */ ("Click and drag to create events")
});